<span i18n="@@requiredField-label-required" class="field-required">
  (Required)
</span>
